import { LocalizedText } from "@/i18n/LocalizedText";
import { BriefcaseBusiness, MoreHorizontal, Trash } from "lucide-react";
import { Button } from "./ui/button";
import { Separator } from "./ui/separator";
import { useNavigate } from "react-router";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { useRef, useState } from "react";

type BrandActionProps = {
  onRequestDelete: (id: string) => void;
  onOpenSettings: () => void;
  brand: { brandId?: string; id?: string };
  setDropDownOpened: (opened: boolean) => void;
  canDeleteBrand?: boolean;
};

const BrandAction = ({
  onRequestDelete,
  onOpenSettings,
  brand,
  setDropDownOpened,
  canDeleteBrand = true,
}: BrandActionProps) => {
  const navigate = useNavigate();
  const [brandActionsopen, setBrandActionsOpen] = useState(false);
  const openingDeleteDialog = useRef(false);

  return (
    <DropdownMenu
      modal={false}
      open={brandActionsopen}
      onOpenChange={setBrandActionsOpen}
    >
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="h-7 p-0 cursor-pointer"
          onClick={(event) => event.stopPropagation()}
          onKeyDown={(event) => event.stopPropagation()}
        >
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        align="end"
        side="bottom"
        className="w-38"
        onFocusOutside={(event) => event.preventDefault()}
        onCloseAutoFocus={(event) => {
          if (openingDeleteDialog.current) event.preventDefault();
        }}
        onPointerMove={(event) => event.stopPropagation()}
        onKeyDown={(event) => event.stopPropagation()}
      >
        <DropdownMenuItem
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onOpenSettings();
            navigate(`/dashboard/settings/brand`);
            setBrandActionsOpen(false);
            setTimeout(() => {
              setDropDownOpened(false);
            }, 300);
          }}
          className="font-normal cursor-pointer flex items-center gap-2"
        >
          <BriefcaseBusiness className="h-4 w-4" />
          <span>
            <LocalizedText id="legacy.brand.settings.pkcpkr" />
          </span>
        </DropdownMenuItem>
        <Separator></Separator>
        <DropdownMenuItem
          onClick={(event) => event.stopPropagation()}
          onSelect={(event) => {
            event.preventDefault();
            const brandId = brand.brandId || brand.id;
            if (brandId) {
              openingDeleteDialog.current = true;
              onRequestDelete(brandId);
              setBrandActionsOpen(false);
              setDropDownOpened(false);
            }
          }}
          disabled={!canDeleteBrand}
          className="font-normal cursor-pointer flex items-center gap-2 text-[#DC2626] focus:text-red-600"
        >
          <Trash className="h-4 w-4 text-[#DC2626]" />
          <span>
            <LocalizedText id="legacy.delete.brand.2ljx5z" />
          </span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default BrandAction;
